import { render, staticRenderFns } from "./layout_main.vue?vue&type=template&id=6de79264"
import script from "./layout_main.vue?vue&type=script&lang=js"
export * from "./layout_main.vue?vue&type=script&lang=js"
import style0 from "./layout_main.vue?vue&type=style&index=0&id=6de79264&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports